var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "col-sm-12 col-xs-12" }, [
    _c(
      "div",
      {
        staticClass: "panel panel-default",
        on: { dblclick: _vm.toggleEditMode }
      },
      [
        _c("div", { staticClass: "panel-heading" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("translate")("Page overview")) +
              "\n        "
          )
        ]),
        _c("ul", { staticClass: "list-group" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "ls-flex-row wrap col-12" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(_vm._s(_vm._f("translate")("Title")))
              ]),
              _c("div", {
                staticClass: "col-12 scoped-small-border",
                domProps: { innerHTML: _vm._s(_vm.cleanCurrentTitle) }
              })
            ])
          ]),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !!_vm.cleancurrentQuestionGroupDescription,
                  expression: "!!cleancurrentQuestionGroupDescription"
                }
              ],
              staticClass: "list-group-item"
            },
            [
              _c("div", { staticClass: "ls-flex-row wrap col-12" }, [
                _c("div", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm._f("translate")("Description")))
                ]),
                _c("div", {
                  staticClass: "col-12 scoped-small-border",
                  domProps: {
                    innerHTML: _vm._s(_vm.cleancurrentQuestionGroupDescription)
                  }
                })
              ])
            ]
          ),
          _c("li", { staticClass: "list-group-item" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !!_vm.currentQuestionGroupRandomgroup,
                    expression: "!!currentQuestionGroupRandomgroup"
                  }
                ],
                staticClass: "ls-flex-row wrap",
                class:
                  _vm.parsedRelevance != 1 && _vm.parsedRelevance != ""
                    ? "col-6"
                    : "col-12"
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm._f("translate")("Random Group")))
                ]),
                _c("div", { staticClass: "col-12 scoped-small-border" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.currentQuestionGroupRandomgroup) +
                      "\n                    "
                  )
                ])
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.parsedRelevance != 1 && _vm.parsedRelevance != "",
                    expression: "(parsedRelevance!=1 && parsedRelevance!='')"
                  }
                ],
                staticClass: "ls-flex-row wrap",
                class: !!_vm.currentQuestionGroupRandomgroup
                  ? "col-6"
                  : "col-12"
              },
              [
                _c("div", { staticClass: "col-12" }, [
                  _vm._v(_vm._s(_vm._f("translate")("Condition")))
                ]),
                _c("div", {
                  staticClass:
                    "col-12 scoped-small-border scoped-showrelevance",
                  domProps: { innerHTML: _vm._s(_vm.parsedRelevance) }
                })
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }